import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appFocusNext]'
})
export class FocusNextDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    event.preventDefault();

    const container = document.getElementById('inputsRow');
    if (!container) return;

    const focusables = Array.from(container.querySelectorAll('input'))
      .filter((el: any) => !el.disabled && el.type !== 'hidden');

    const index = focusables.indexOf(this.el.nativeElement);

    if (index >= 0 && index < focusables.length - 1) {
      const next = focusables[index + 1] as HTMLInputElement;
      next.focus();
      next.select();
    } else {
      const saveButton = document.getElementById('saveButton');
      if (saveButton) saveButton.focus();
    }
  }
}
